module.exports = __webpack_public_path__ + "img/icon-move4water.a6a6784e.png";